import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { PayloadAction } from 'typesafe-actions';
import { ActivityLogState, ActivityLogActionTypes } from './types';
import { defaultState } from './defaultState';

const ActivityLogContext = createContext<Partial<ActivityLogState>>(defaultState);
const ActivityLogDispatchContext = createContext<Dispatch<PayloadAction<ActivityLogActionTypes, any>> | undefined>(
  undefined,
);

export { ActivityLogContext, ActivityLogDispatchContext };
